(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-seo"] && !Shopify.designMode) return;
  try {
    (function () {
    // Chapters: longer ones go to the left column (ceil(n/2)), reading order kept inside each column
    document.querySelectorAll('.nuno-cat-seo__body').forEach(function (body) {
      var chapters = Array.prototype.slice.call(body.querySelectorAll(':scope > .nuno-chapter'));
      if (chapters.length < 2) return;
      var leftCount = Math.ceil(chapters.length / 2);
      var longest = chapters.slice().sort(function (a, b) {
        return b.textContent.length - a.textContent.length;
      }).slice(0, leftCount);
      var left = document.createElement('div');
      var right = document.createElement('div');
      left.className = right.className = 'nuno-chapter-col';
      chapters.forEach(function (chapter, index) {
        chapter.style.order = index;
        (longest.indexOf(chapter) > -1 ? left : right).appendChild(chapter);
      });
      body.appendChild(left);
      body.appendChild(right);
    });

    var scenes = document.querySelectorAll('[data-nuno-scene]');
    if (!scenes.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var clamp = function (v, min, max) { return Math.min(max, Math.max(min, v)); };
    var easeInOut = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

    scenes.forEach(function (scene) {
      var frame = scene.querySelector('.nuno-scene__frame');
      var layers = Array.prototype.slice.call(scene.querySelectorAll('[data-depth]'));
      var heading = scene.querySelector('[data-rise]');
      var layered = scene.classList.contains('nuno-scene--layered');
      var nearest = layers.reduce(function (max, layer) { return Math.max(max, parseFloat(layer.dataset.depth)); }, 0);
      var TITLE_DROP = 0.08;
      var STRENGTH = 1.6;
      var queued = false;

      function render() {
        queued = false;
        var vh = window.innerHeight;
        var rect = frame.getBoundingClientRect();
        // 0 when the box enters at the bottom of the screen, 1 when it leaves at the top
        var travel = clamp((vh - rect.top) / (vh + rect.height), 0, 1);
        var boxH = rect.height;

        if (layered) {
          // Anchored at the bottom: the nearest layer stays, every farther one sinks below it,
          // so nearer layers always cover the cut edges of farther ones and no gap opens at the bottom.
          var eq = easeInOut(clamp((travel - 0.1) / 0.8, 0, 1)) * STRENGTH;
          layers.forEach(function (layer) {
            var y = (nearest - parseFloat(layer.dataset.depth)) * eq * boxH;
            layer.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
          });
          if (heading) heading.style.transform = 'translate3d(0,' + (TITLE_DROP * eq * boxH).toFixed(1) + 'px,0)';
        } else {
          layers.forEach(function (layer) {
            var y = (0.5 - travel) * parseFloat(layer.dataset.depth) * boxH * 0.2;
            layer.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
          });
        }
      }

      function request() {
        if (!queued) {
          queued = true;
          requestAnimationFrame(render);
        }
      }

      var section = scene.closest('.nuno-cat-seo');
      var rail = section && section.querySelector('[data-rail]');
      function fitRail() {
        if (!rail) return;
        var lead = section.querySelector('.nuno-cat-seo__lead');
        if (!lead) return;
        var story = rail.parentElement;
        var target = lead.offsetHeight;
        if (getComputedStyle(rail).display === 'none') return;
        var size = parseFloat(getComputedStyle(rail).fontSize);
        var length = rail.getBoundingClientRect().height;
        if (length > 0) rail.style.fontSize = (size * target / length).toFixed(2) + 'px';
      }
      fitRail();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitRail);
      window.addEventListener('resize', fitRail);

      var preload = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        scene.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        preload.disconnect();
      }, { rootMargin: '200% 0px' });
      preload.observe(scene);

      if (reduceMotion.matches) return;
      render();
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          window.addEventListener('scroll', request, { passive: true });
          request();
        } else {
          window.removeEventListener('scroll', request);
        }
      });
      observer.observe(scene);
      window.addEventListener('resize', request);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
